import React from 'react';
import { Guide } from '../components/Guide';
import { Hero } from '../components/Hero';
import { Information } from '../components/Information';
import { Itinerary } from '../components/Itinerary';
import { Pricing } from '../components/Pricing';
export function ManasluCircuitPage() {
  return <main className="manaslu-circuit-content" data-id="element-615" data-mp="603p2pa3pd5v">
      <Hero data-id="element-616" data-mp="60vn06r67mzb" />
      <Guide data-id="element-617" data-mp="62pyyvkgs4r9" />
      <Itinerary data-id="element-618" data-mp="tq7savjdnawc" />
      <Pricing data-id="element-619" data-mp="tpoarfxn2oiu" />
      <Information data-id="element-620" data-mp="tr94x4g1k5g6" />
    </main>;
}